<template>
  <div class="fab__popup">
    <div class="fab__popup__header">
      <p>Benötigen Sie Hilfe?</p>
      <button @click="closeButton" aria-label="Hilfedialog schließen">
        <IconClose aria-hidden="true" />
      </button>
    </div>
    <hr />
    <div class="fab__popup__body">
      <p class="fab__popup__text">
        Sie können uns rund um die Uhr unter folgender Nummer oder E-Mail erreichen.
      </p>
      <a class="fab__popup__section" :href="'tel:' + landesclubTelephone">
        <IconPhone aria-hidden="true" />
        <p>{{ landesclubTelephone }}</p>
        <IconChevronRight aria-hidden="true" class="fab__popup__section__right" />
      </a>
      <hr class="fab__popup__section__separator" />
      <a
        class="fab__popup__section"
        href="https://www.oeamtc.at/kontakt/#online-17417796"
        target="_blank"
      >
        <IconEmail aria-hidden="true" />
        <p>Zum Kontaktformular</p>
        <IconChevronRight aria-hidden="true" class="fab__popup__section__right" />
      </a>
    </div>
  </div>
</template>

<script>
import IconChevronRight from '@/components/icons/IconChevronRight.vue'
import IconClose from '@/components/icons/IconClose.vue'
import IconEmail from '@/components/icons/IconEmail.vue'
import IconPhone from '@/components/icons/IconPhone.vue'
import { mapGetters } from 'vuex'

export default {
  components: { IconClose, IconPhone, IconEmail, IconChevronRight },
  emits: ['closeInfo'],
  computed: {
    ...mapGetters(['isMobile', 'landesclubTelephone']),
  },
  methods: {
    closeButton() {
      document.querySelector('.fab__button').click() // simulate click away for popover
      this.$emit('closeInfo')
    },
  },
}
</script>

// scss comes from ContactFAB.vue
